import { Fab as MuiFab, FabProps as MuiFabProps } from '@material-ui/core';

export type FabProps = MuiFabProps;

export const Fab = MuiFab;
